<template>
  <v-dialog
    scrollable
    @input="$emit('update:opened', $event)"
    :value="opened"
    max-width="1031px"
  >
    <v-card>
      <v-card-title class="pb-1">
        <v-container class="pb-0">
          <v-row>
            <v-col class="pb-0">
              <h4 class="display-1 font-weight-bold">
                Pojmenujte své publikum
              </h4>
              <p class="body-2 mb-0">
                Zvolte si co nejpopisnější název, abyste si v budoucnu usnadnili
                práci s publiky
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>

      <v-card-text>
        <v-container class="pt-6">
          <v-text-field
            label="Název publika"
            outlined
            name="audienceName"
            type="text"
            hide-details
            :value="name"
            @input="$emit('input', $event)"
          />
        </v-container>
      </v-card-text>

      <v-card-actions class=".c-dialog__footer px-6">
        <v-container class="py-4">
          <div class="d-flex justify-space-between">
            <v-btn @click="$emit('update:opened', false)" min-width="160">
              Zavřít
            </v-btn>

            <v-btn
              color="primary"
              class="c-btn"
              min-width="160"
              @click="
                $emit('confirm')
                $emit('update:opened', false)
              "
            >
              Uložit
            </v-btn>
          </div>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SaveAudienceDialog",
  model: {
    prop: "name",
    event: "input",
  },
  props: {
    opened: { type: Boolean, default: false },
    name: { type: String, default: null },
  },
  emits: {
    "update:opened": e => typeof e === "boolean",
    "confirm": null,
  },
}
</script>

<style scoped></style>
